<template>
  <v-card flat>
    <v-list-item two-line class="pt-0">
      <v-list-item-content>
        <v-list-item-title class="headline">Mes demandes</v-list-item-title>
        <v-list-item-subtitle
          >Veuillez sélectionner une demande pour y
          accéder</v-list-item-subtitle
        >
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="3">
          <search-by
            :datasource="datasourceDemande"
            attr="status"
            type="select"
            :items="enums.statusDemande"
            i18n="demande.list.headers.status"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <search-by
            :datasource="datasourceDemande"
            type="select"
            :items="enums.typesDemande"
            attr="demandeType"
            i18n="demande.list.headers.demandeType"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <search-by
            :datasource="datasourceDemande"
            type="select"
            attr="type"
            :items="enums.types"
            i18n="demande.list.headers.demandeObjet"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <search-by
            :datasource="datasourceDemande"
            type="date"
            attr="dateModification"
            i18n="demande.list.headers.dateModification"
          />
        </v-col>
      </v-row>

      <v-container fluid>
        <datasource-table
          ref="dataTable"
          :datasource="datasourceDemande"
          @click:row="selectedItemTraitements"
        >
          <template #item.demandeType="{item}">
            {{ item.demandeType.libelle }}
          </template>

          <template #item.typeEntite="{item}">
            {{ formatTypeEntite(item.typeEntite) }}
          </template>

          <template #item.status="{item}">
            {{ item.status.libelle }}
          </template>

          <template #item.concerne="{item}">
            <template v-if="item.concerne">
              <template v-if="item.concerne.libelle">
                {{ item.concerne.libelle }}
              </template>
              <template v-else-if="item.concerne.nomUsuel">
                {{ item.concerne.nomUsuel }}
              </template>
            </template>
          </template>

          <template #item.dateModification="{item}">
            {{ formatDate(item.dateModification) }}
          </template>

          <template #item.dateCreation="{item}">
            {{ formatDate(item.dateCreation) }}
          </template>
        </datasource-table>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';
import moment from 'moment';

export default {
  mounted() {
    this.datasourceDemande.refresh();
  },
  beforeMount() {
    this.creationPromiseEnums();
  },
  data() {
    const datasourceDemande = new Datasource('workflow/demande/mes-demandes', {
      page: 1,
      rowsPerPage: 20,
      sortBy: 'dateCreation',
      descending: false,
      selectAll: this.selectAll,
      labelNamespace: 'demande.list',
      args: { actif: true },
      fields: [
        {
          value: 'demandeType',
          sortable: true,
        },
        {
          value: 'typeEntite',
          sortable: true,
        },
        {
          value: 'concerne',
          sortable: false,
        },
        {
          value: 'status',
          sortable: true,
        },
        {
          value: 'commentaire',
          sortable: false,
        },
        {
          value: 'dateCreation',
          sortable: true,
        },
        {
          value: 'dateModification',
          sortable: true,
        },
      ],
    });
    return {
      datasourceDemande,
      enums: {
        typesDemande: [],
        statusDemande: [],
        types: ['Contact', 'Personne morale', 'Instance'],
      },
    };
  },
  methods: {
    selectedItemTraitements(item) {
      switch (item.typeEntite) {
        case 'DemandePersonneMorale':
          this.$router.push({
            name: 'workflow/mesdemandes/personnemorale/detail',
            params: {
              id: item.id,
            },
          });
          break;

        case 'DemandeContact':
          this.$router.push({
            name: 'workflow/mesdemandes/personne-physique/detail',
            params: {
              id: item.id,
            },
          });
          break;
        case 'DemandeInstance':
          this.$router.push({
            name: 'workflow/mesdemandes/instance/detail',
            params: {
              id: item.id,
            },
          });
          break;
        case 'DemandeContactMobile':
          this.$router.push({
            name: 'workflow/mesdemandes/personne-mobile/detail',
            params: {
              id: item.id,
            },
          });
          break;
      }
    },

    creationPromiseEnums() {
      return this.$api('enums/demande')
        .get()
        .then(response => {
          const body = response.body;
          this.initEnums(body);
        });
    },

    formatTypeEntite(item) {
      if (item === 'DemandeContact') {
        return 'Contact';
      }
      if (item === 'DemandePersonneMorale') {
        return 'Personne morale';
      }
      if (item === 'DemandeInstance') {
        return 'Instance';
      }
      return 'TODO';
    },

    initEnums(body) {
      const enums = this.enums;
      enums.typesDemande = body.typesDemande;
      enums.statusDemande = body.statusDemande;
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY [à] HH:mm') : null;
    },
  },
};
</script>
